export const ALL_ITEM_ECOMERCE_ASISTANT = [
  {
    categry: "eComerceAsistant",
    itemList: [
      {
        itemSelected: "noemi",
        itemName: "Noemi",
        itemDescription:
          "Noemi is an e-commerce assistant packaging that is produced to help online businesses transfer their product safely yet beautifully.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/E-Commerce/Noemi/Desktop/700x700px/lussopack-ecommerce-noemi-01.webp",
          "/images/listItem/E-Commerce/Noemi/Desktop/700x700px/lussopack-ecommerce-noemi-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/E-Commerce/Noemi/Desktop/130x130px/lussopack-ecommerce-noemi-01.webp",
          "/images/listItem/E-Commerce/Noemi/Desktop/130x130px/lussopack-ecommerce-noemi-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/E-Commerce/Noemi/Mobile/335x335px/lussopack-ecommerce-noemi-01.webp",
          "/images/listItem/E-Commerce/Noemi/Mobile/335x335px/lussopack-ecommerce-noemi-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/E-Commerce/Noemi/Mobile/100x100px/lussopack-ecommerce-noemi-01.webp",
          "/images/listItem/E-Commerce/Noemi/Mobile/100x100px/lussopack-ecommerce-noemi-02.webp",
        ],
      },
    ],
  },
];
